module.exports = __webpack_public_path__ + "static/media/appAdvertTopLogo_white.b4060a97.svg";